var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.385,
    height: 5.805,
    viewBox: "0 0 8.385 5.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-mail",
    "data-name": "Icon ionic-ios-mail",
    transform: "translate(-3.375 -7.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M11.691,10.326,9.523,12.535a.039.039,0,0,0,0,.056l1.518,1.617a.262.262,0,0,1,0,.371.263.263,0,0,1-.371,0l-1.512-1.61a.041.041,0,0,0-.058,0l-.369.375a1.623,1.623,0,0,1-1.157.488,1.655,1.655,0,0,1-1.181-.5l-.355-.361a.041.041,0,0,0-.058,0l-1.512,1.61a.263.263,0,0,1-.371,0,.262.262,0,0,1,0-.371l1.518-1.617a.043.043,0,0,0,0-.056L3.444,10.326a.04.04,0,0,0-.069.028v4.42a.647.647,0,0,0,.645.645h7.095a.647.647,0,0,0,.645-.645v-4.42A.04.04,0,0,0,11.691,10.326Z",
    transform: "translate(0 -1.74)",
    fill: "rgba(0,0,0,0.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M8.174,11.566a1.1,1.1,0,0,0,.788-.331l3.162-3.219a.633.633,0,0,0-.4-.141h-7.1a.629.629,0,0,0-.4.141l3.162,3.219A1.1,1.1,0,0,0,8.174,11.566Z",
    transform: "translate(-0.607)",
    fill: "rgba(0,0,0,0.64)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.dd043ee33a275bd2badfa0ebee9407ac.svg";
export { ForwardRef as ReactComponent };